//import { useState } from "react";
// import { loadStripe } from "@stripe/stripe-js";
import { useSupabaseUser } from './useSupabaseUser';
import { useState, useEffect } from "react";
import { useUser } from "@clerk/clerk-react";

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
///console.log("Price ID:", process.env.REACT_APP_STRIPE_PRO_PRICE_ID); /// to capture error
const COLORS = {
  bg: "#020617", surface: "#0F172A", border: "rgba(255,255,255,0.10)",
  accent: "#60A5FA", purple: "#A78BFA", green: "#34D399",
  text: "#FFFFFF", textMuted: "#94A3B8",
};

export default function Pricing({ onClose }) {
  const { user } = useUser();
  const [loading] = useState(null);
  const [annual, setAnnual] = useState(false);

  const { updatePlan } = useSupabaseUser() || {};

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get("subscribed") === "true") {
    updatePlan && updatePlan("pro");
  }
}, [updatePlan]); // eslint-disable-line react-hooks/exhaustive-deps

  const plans = [
    {
      name: "Basic",
      price: annual ? 7 : 9,
      priceId: process.env.REACT_APP_STRIPE_BASIC_PRICE_ID,
      color: COLORS.accent,
      features: [
        "Access to 50+ free courses",
        "AI Skill Path Generator",
        "Community access",
        "Mobile app access",
        "Progress tracking",
      ],
    },
    {
      name: "Pro",
      price: annual ? 15 : 19,
      priceId: process.env.REACT_APP_STRIPE_PRO_PRICE_ID,
      color: COLORS.purple,
      popular: true,
      features: [
        "Everything in Basic",
        "Unlimited premium courses",
        "Career Pack access",
        "1-on-1 coaching discounts (20% off)",
        "Creator dashboard access",
        "Priority support",
        "Certificates of completion",
      ],
    },
  ];

 const handleSubscribe = (plan) => {
  if (!user) {
    alert("Please sign in first to subscribe.");
    return;
  }

  const paymentLinks = {
    Basic: process.env.REACT_APP_STRIPE_BASIC_PAYMENT_LINK,
    Pro: process.env.REACT_APP_STRIPE_PRO_PAYMENT_LINK,
  };

  const link = paymentLinks[plan.name];
  if (link) {
    const email = user.primaryEmailAddress?.emailAddress || "";
    window.location.href = `${link}?prefilled_email=${encodeURIComponent(email)}`;
  } else {
    alert("Payment link not configured.");
  }
};
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(2,6,23,0.85)", backdropFilter: "blur(12px)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}`, borderRadius: 24, padding: "40px 36px", maxWidth: 720, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 24px 80px rgba(0,0,0,0.6)" }}>

        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.accent, letterSpacing: "1px", textTransform: "uppercase", marginBottom: 6 }}>Simple Pricing</div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 32, fontWeight: 900, color: COLORS.text }}>Choose Your Plan</h2>
          </div>
          {onClose && <button onClick={onClose} style={{ background: "none", border: "none", color: COLORS.textMuted, fontSize: 22, cursor: "pointer" }}>✕</button>}
        </div>

        {/* Annual toggle */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32, marginTop: 16 }}>
          <span style={{ fontSize: 14, color: annual ? COLORS.textMuted : COLORS.text, fontFamily: "'DM Sans', sans-serif" }}>Monthly</span>
          <div onClick={() => setAnnual(!annual)} style={{ width: 44, height: 24, borderRadius: 12, background: annual ? COLORS.accent : COLORS.border, cursor: "pointer", position: "relative", transition: "background 0.2s" }}>
            <div style={{ position: "absolute", top: 3, left: annual ? 23 : 3, width: 18, height: 18, borderRadius: "50%", background: "#fff", transition: "left 0.2s" }} />
          </div>
          <span style={{ fontSize: 14, color: annual ? COLORS.text : COLORS.textMuted, fontFamily: "'DM Sans', sans-serif" }}>
            Annual <span style={{ fontSize: 11, color: COLORS.green, fontWeight: 700 }}>Save 20%</span>
          </span>
        </div>

        {/* Plans */}
        <div className="pricing-plans" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
          {plans.map(plan => (
            <div key={plan.name} style={{ borderRadius: 16, border: `2px solid ${plan.popular ? plan.color : COLORS.border}`, padding: "28px 24px", background: plan.popular ? plan.color + "10" : "transparent", position: "relative" }}>
              {plan.popular && (
                <div style={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", background: plan.color, color: "#000", fontSize: 11, fontWeight: 800, padding: "4px 14px", borderRadius: 20, letterSpacing: "0.5px", whiteSpace: "nowrap" }}>
                  MOST POPULAR
                </div>
              )}
              <div style={{ fontSize: 16, fontWeight: 700, color: plan.color, marginBottom: 8, fontFamily: "'DM Sans', sans-serif" }}>{plan.name}</div>
              <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginBottom: 20 }}>
                <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 42, fontWeight: 900, color: COLORS.text }}>${plan.price}</span>
                <span style={{ fontSize: 13, color: COLORS.textMuted }}>/month</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 24 }}>
                {plan.features.map(f => (
                  <div key={f} style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                    <span style={{ color: COLORS.green, fontSize: 14, marginTop: 1 }}>✓</span>
                    <span style={{ fontSize: 13, color: COLORS.textMuted, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.5 }}>{f}</span>
                  </div>
                ))}
              </div>
              <button
  onClick={() => handleSubscribe(plan)}
  disabled={loading === plan.name}
  style={{
    width: "100%",
    padding: "13px",
    borderRadius: 10,
    background: plan.popular ? plan.color : "transparent",
    color: plan.popular ? "#000" : plan.color,
    border: plan.popular ? `2px solid transparent` : `2px solid ${plan.color}`,
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: 700,
    fontSize: 14,
    cursor: loading === plan.name ? "wait" : "pointer",
    transition: "all 0.2s",
    opacity: loading === plan.name ? 0.7 : 1
  }}>
  {loading === plan.name ? "Redirecting..." : `Get ${plan.name} →`}
</button>
            </div>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: COLORS.textMuted }}>
          🔒 Secured by Stripe · Cancel anytime · No hidden fees
        </div>
      </div>
    </div>
  );
}